export enum Industry {
  AGRICULTURE = 'Agriculture',
  AUTOMOTIVE = 'Automotive',
  AVIATION_AIRLINES = 'Aviation / Airlines',
  CHEMICALS = 'Chemical',
  CONSTRUCTION = 'Construction',
  ENERGY_POWER = 'Energy / Power',
  ENGINEERING_SERVICES = 'Engineering Services',
  ENVIRONMENTAL_WASTE_MANAGEMENT = 'Environmental Waste Management',
  FOOD_BEV = 'Food and Beverage',
  GOVERNMENT = 'Government',
  HEALTHCARE_MEDICAL = 'Healthcare / Medical',
  HOSPITALITY = 'Hospitality (Hotel / Resort / Casino)',
  INDUSTRIAL_MANUFACTURING = 'Industrial Manufacturing',
  LOGISTICS_SHIPPING_TRANSPORTATION = 'Logistics / Shipping / Transportation',
  MARINE_SHIPYARD = 'Marine / Shipyard',
  METAL_STEEL_FABRICATION = 'Metals / Steel / Fabrication',
  MINING = 'Mining',
  OIL_GAS_PETROCHEMICAL = 'Oil & Gas / Petrochemical',
  PACKAGING = 'Packaging',
  PAPER_PULP = 'Paper / Pulp',
  PHARMACEUTICAL = 'Pharmaceutical',
  PLASTICS = 'Plastics',
  PRINTING_PUBLISHING = 'Printing / Publishing',
  RETAIL_TRADE_IMPORTER = 'Retail / Trading / Importer',
  SEMICONDUCTOR_ELECTRONICS = 'Semiconductor / Electronics',
  UTILITIES = 'Utilities (Water / Electric)',
  EDUCATION = 'Education',
  REAL_ESTATE = 'Real Estate / Property',
  SERVICES_GENERAL = 'Services (General)',
  OTHER = 'Other'
}

export enum ProductCategory {
  SCADA_AUTOMATION = 'Scada Automation',
  PANEL_BUILDING = 'Panel Building',
  OT_SECURITY = 'OT Security',
  INSTRUMENTATION = 'Instrumentation',
  ELECTRICAL = 'Electrical',
  MECHANICAL = 'Mechanical',
  PNEUMATICS = 'Pneumatics',
  OTHER = 'Other'
}

export enum Brand {
  AVEVA = 'Aveva',
  SCHNEIDER = 'Schneider',
  FORTINET = 'Fortinet',
  YOKOGAWA = 'Yokogawa',
  ALLEN_BRADLEY = 'Allen-Bradley',
  CHARGE_UPS = 'ChargeUPS',
  TURCK_BANNER = 'Turck Banner',
  FESTO = 'Festo',
  SIEMENS = 'Siemens',
  FINETEK = 'Finetek',
  OTHER = 'Other'
}

export enum VatType {
  EXCLUSIVE = 'Exclusive',
  INCLUSIVE = 'Inclusive',
  ZERO_RATED = 'Zero - Rated'
}

export enum FormMode {
  ADD = 'add',
  EDIT = 'edit',
  VIEW = 'view'
}

export enum CategoryTypes {
  PROJECT = 'Project',
  SUPPLIES = 'Supplies'
}